import { useMemo } from 'react'

import { AccountType } from '@app/models'
import { hasAccountType } from '@app/store/user'

import { useUser } from './useUser'

export const useHasAccountType = (type: AccountType) => {
  const userState = useUser()

  return useMemo(() => hasAccountType(userState)(type), [type, userState])
}

export const useIsDeveloper = () => useHasAccountType('Developer')
